export default __webpack_public_path__ + "static/media/f0021-01.2f446c08.png";